import { Input, Label } from "reactstrap";

const PopularCoinsTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <div className="form-check">
            <Input type="checkbox" />
            <Label className="form-check-label" />
          </div>
        </th>
        <th>Name</th>
        <th>Price</th>
        <th className="text-center">24h%</th>
        <th className="text-center">7d%</th>
        <th>Market Cap</th>
        <th>Volume(24h)</th>
      </tr>
    </thead>
  );
};

export default PopularCoinsTableHeader;
